<template>
    <section v-if="isVisibleOnSmallScreens" class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <div class="columns">
                    <div class="column is-4 is-offset-4">
                        <!-- <p class="has-text-centered"><img src="/public/img/logo.png" style="max-width: 100%"></p> -->
                        <p class="has-text-centered logo mb">Ordino</p>

                        <form @submit.prevent="handleResetPassword">
                            <o-field label="Email" :type="fieldType('email')" :message="getError('email')">
                                <o-input placeholder="email@example.com" v-model="form.email" autofocus/>
                            </o-field>

                            <o-field label="New password" :type="fieldType('password')" :message="getError('password')">
                                <o-input password-reveal type="password" placeholder="" v-model="form.password" :class="'reveal-external'" />
                            </o-field>

                            <o-field label="Confirm password" :type="fieldType('password')" :message="getError('password')">
                                <o-input password-reveal type="password" placeholder="" v-model="form.password_confirmation" :class="'reveal-external'" />
                            </o-field>

                            <button class="button is-primary is-pulled-right" v-submit="submitting">
                                <span class="icon">
                                  <i class="fa fa-sign-in"></i>
                                </span>
                                <span>Reset</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapActions} from 'vuex'
    import HandlesForm from '../mixins/HandlesForm'
    import SmallScreensConfirmationMixin from '../mixins/SmallScreensConfirmation.js'

    export default {
        mixins: [SmallScreensConfirmationMixin, HandlesForm],

        data() {
            return {
                form: {email: '', password: '', password_confirmation: '', token: this.$route.params.token}
            }
        },

        methods: {
            ...mapActions(['resetPassword', 'setCurrentUser']),

            handleResetPassword () {
                let submit = this.wrapSubmit(this.resetPassword)
                submit(this.form)
                    .then(res => {
                        // this.setCurrentUser(res.data.data)
                        this.$router.push({ name:  res.data.data.role === 'employee' ? 'projects.index' : 'dashboard.proposals' })

                        this.$swal.fire({
                            text: 'Password has been successfull changed',
                            icon: 'success'
                        })

                        setTimeout(() => {
                          window.location.reload()
                        }, 800)
                        return res
                    })
            }
        }
    }
</script>
